<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-title>Complete your payment</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div sxPadding="large" sxCol sxAlign="center">

    <div *ngIf="loading" sxCol sxAlign="center">
      <p sxTextSize="medium">Loading…</p>
    </div>

    <div *ngIf="!loading && notFound" sxCol sxAlign="center" sxGap="10px">
      <p sxTextSize="large" sxTextWeight="bold">Link not found</p>
      <p sxTextSize="medium" sxColor="medium">This payment link is invalid or has expired. Please contact QID.</p>
    </div>

    <div *ngIf="!loading && order" sxCol sxGap="10px" sxWidth="full" style="max-width: 460px;">

      <!-- Success -->
      <div *ngIf="isPaid" sxCol sxAlign="center" sxGap="10px">
        <p sxTextSize="large" sxTextWeight="bold">Payment received 🎉</p>
        <p sxTextSize="medium" sxColor="medium">Your plan is active. You can close this page and continue using QID.</p>
      </div>

      <!-- Pending payment -->
      <div *ngIf="!isPaid" sxCol sxGap="10px">

        <div *ngIf="order.instantActivation" sxBackground="dark" sxRadius="medium" sxPadding="medium" sxColor="light">
          <p sxMargin="0" sxTextSize="medium">
            Your plan is already active. Please complete payment by
            <span sxTextWeight="bold">{{ order.paymentDueDate | date: 'mediumDate' }}</span>
            to keep your account active.
          </p>
        </div>

        <div sxBackground="dark" sxRadius="medium" sxPadding="large" sxColor="light" sxCol sxGap="10px">
          <p sxMargin="0" sxTextSize="medium" sxColor="medium">{{ order.organisationName }}</p>
          <p sxMargin="0" sxTextSize="large" sxTextWeight="bold">{{ order.planName }} ({{ order.period }})</p>
          <p sxMargin="0" sxTextSize="large">&#8377;{{ order.amount }}</p>
        </div>

        <super-button *ngIf="order.razorpayShortUrl" background="dark" iconStart="card" (click)="payNow()">
          Pay securely
        </super-button>
        <p *ngIf="!order.razorpayShortUrl" sxTextSize="small" sxColor="medium" sxTextAlign="center">
          Payment is being set up. Please refresh in a moment.
        </p>

        <p sxTextSize="small" sxColor="medium" sxTextAlign="center">
          You'll be taken to our secure payment partner. This page updates automatically once payment is done.
        </p>
      </div>

    </div>

  </div>
</ion-content>
